import { OverflownTextTooltip } from 'components/OverflownTextTooltip'

interface TruncatedTextCellProps {
  text: string
  tooltipText?: string
}

export const TruncatedTextCell = ({
  text,
  tooltipText,
}: TruncatedTextCellProps) => {
  return (
    <div className="max-w-full" style={{ minWidth: 0, flex: 1 }}>
      <OverflownTextTooltip tooltipText={tooltipText || text}>
        <div
          style={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </div>
      </OverflownTextTooltip>
    </div>
  )
}
